import config from "./config"

export default {
    sso: config.ssoBaseUrl,  
    logout: config.ssoBaseUrl + "/logout?appId=" + config.appId,
    login: config.ssoBaseUrl + "/login",
    tokenValidate: config.ssoBaseUrl + "/validateJWT",

    userinfo: config.ucenterApiBaseUrl + "/usercenter/userinfo",
    applist: config.ucenterApiBaseUrl + "/usercenter/applist",
    authapps: config.ucenterApiBaseUrl + "/usercenter/authapps",
    subsites: config.ucenterApiBaseUrl + "/usercenter/subsites",
    statdata: config.ucenterApiBaseUrl + "/usercenter/iotstat",

    projectData: config.ucenterApiBaseUrl + "/usercenter/projects",
    monitorData: config.ucenterApiBaseUrl + "/usercenter/monitorobjects",

    openApply: config.ucenterApiBaseUrl + "/usercenter/openrequest",
    orgLogo: config.ucenterApiBaseUrl + "/usercenter/orglogo",

    storagestat: config.ucenterApiBaseUrl + "/usercenter/storagestat",
    storagedetails: config.ucenterApiBaseUrl + "/usercenter/storagedetails",
    detailexport: config.ucenterApiBaseUrl + "/usercenter/detailexport",
    // expreience: config.ucenterApiBaseUrl + "/usercenter/experiencesync"
    getmonirortypes:config.ucenterApiBaseUrl +'/usercenter/monitortypes',
    addproject:config.ucenterApiBaseUrl + "/usercenter/projectadd",
    editproject:config.ucenterApiBaseUrl + "/usercenter/projectedit"
}


// WEBPACK FOOTER //
// ./src/utils/apis.js